import styled from "styled-components";
import { spacing } from "@magicbi/ui-library";

/** The three radio rows, 12px apart (as ScheduleEndsField's rows). */
export const Rows = styled.div`
  display: grid;
  gap: ${spacing[3]};
  min-width: 0;
`;

/** A radio in a fixed column, then its controls; the controls wrap under it when narrow. */
export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${spacing[2]} ${spacing[4]};
  min-width: 0;
`;

/** Fixed label column so the three rows' controls line up. */
export const RadioSlot = styled.div`
  flex: 0 0 ${spacing[28]};
`;

export const Controls = styled.div`
  flex: 1 1 16rem;
  display: flex;
  align-items: center;
  gap: ${spacing[2]};
  min-width: 0;
`;

/** One select among the controls; two share the row equally. */
export const Control = styled.div`
  flex: 1 1 0;
  min-width: 0;
`;
